export const contentList = ["book", "video", "website", "challenges"];
export const recommendationList = ["✅", "❌", "🧐"];
export const buildWeekList = [1, 2, 3, 4, 5, 6, 7, 8];
